import { render } from 'preact';
import { html } from 'htm/preact';
import NewsArchiveWidget from './news-archive-widget';

function parseDataset({ input = '', fallback }) {
  try {
    return JSON.parse(input);
  } catch (err) {
    // Do nothing.
  }

  return fallback;
}

async function mount({ rootElement = null }) {
  // const preact = await import('preact');
  // const htm = await import('htm/preact');

  const {
    serviceCategories, translations, language, typesToSearch,
  } = rootElement.dataset;
  const container = rootElement.querySelector('.news-archive');

  const options = {
    typesToSearch: parseDataset({ input: typesToSearch, fallback: [] }),
    serviceCategories: parseDataset({ input: serviceCategories, fallback: [] }),
    translations: parseDataset({ input: translations, fallback: [] }),
    language,
  };

  render(html`
    <${NewsArchiveWidget}
      typesToSearch=${options.typesToSearch}
      serviceCategories=${options.serviceCategories}
      translations=${options.translations}
      language=${options.language}
    />`, container);
}

function init() {
  const blocks = document.querySelectorAll('.section--news-archive');

  [...blocks].forEach((block) => {
    mount({ rootElement: block });
  });
}

export default init;
